import { render, staticRenderFns } from "./index.vue?vue&type=template&id=498142aa&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498142aa')) {
      api.createRecord('498142aa', component.options)
    } else {
      api.reload('498142aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=498142aa&", function () {
      api.rerender('498142aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/index.vue"
export default component.exports